import { Component, ErrorInfo } from 'react'

type Props = {
  children: React.ReactNode
  onError?(err: Error): void
}

export class ErrorBoundary extends Component<Props> {
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error({ error, errorInfo })
    this.props.onError?.(error)
  }

  render() {
    return this.props.children
  }
}
